import React from "react";
import { Navigate } from "react-router-dom";
import RootPage from "../../scenes/rootPage";
import { CourseShell } from "./guards";

const HomePage = React.lazy(() => import("../../scenes/homePage"));
const NotificationPage = React.lazy(() => import("../../scenes/notificationsPage"));
const LoginPage = React.lazy(() => import("../../scenes/loginPage"));
const ProfilePage = React.lazy(() => import("../../scenes/profilePage"));
const StatsPage = React.lazy(() => import("../../scenes/statsPage"));
const ExplorePage = React.lazy(() => import("../../scenes/explorePage"));
const FollowersPage = React.lazy(() => import("../../scenes/profilePage/FollowersPage"));
const FollowingPage = React.lazy(() => import("../../scenes/profilePage/FollowingPage"));
const DecksPage = React.lazy(() => import("../../scenes/decksPage"));
const EditDeckPage = React.lazy(() => import("../../scenes/decksPage/EditDeckPage"));
const StudyPage = React.lazy(() => import("../../scenes/studyPage"));
const AdminPage = React.lazy(() => import("../../scenes/adminPage"));
const ResourcesPage = React.lazy(() => import("../../scenes/resourcesPage"));
const CommunityPage = React.lazy(() => import("../../scenes/communityPage"));
const UpdatesPage = React.lazy(() => import("../../scenes/updatesPage"));
const EmailVerifiedPage = React.lazy(() => import("../../scenes/emailVerifiedPage"));
const AuthCallbackPage = React.lazy(() => import("../../scenes/authCallbackPage"));
const KankiPage = React.lazy(() => import("../../scenes/kankiPage"));
const SharedConfigsPage = React.lazy(() => import("../../scenes/kankiCommunityPage"));
const ForumPage = React.lazy(() => import("../../scenes/forumPage"));
const LeaderboardsPage = React.lazy(() => import("../../scenes/leaderboardsPage"));
const PostPage = React.lazy(() => import("../../scenes/postPage"));
const MarketplacePage = React.lazy(() => import("../../scenes/marketplace"));
const LearnPage = React.lazy(() => import("../../scenes/learnPage"));
const LearnVocabPage = React.lazy(() => import("../../scenes/learnPage/LearnVocabPage"));
const CoursePage = React.lazy(() => import("../../scenes/coursePage"));
const CoursesPage = React.lazy(() => import("../../scenes/coursesPage"));
const BlogPage = React.lazy(() => import("../../scenes/blogPage"));
const BlogPostPage = React.lazy(() => import("../../scenes/blogPage/BlogPostPage"));
const DeckPage = React.lazy(() => import("../../scenes/deckPage"));
const PricingPage = React.lazy(() => import("../../scenes/pricingPage"));

// Routes that are public (no auth required, no app shell)
export const publicRoutes = [
  { path: "/kanki", element: <KankiPage /> },
  { path: "/learn", element: <CourseShell><ResourcesPage /></CourseShell> },
  { path: "/learn/:language", element: <CourseShell><LearnPage /></CourseShell> },
  { path: "/learn/:language/vocabulary", element: <CourseShell><LearnVocabPage /></CourseShell> },
  { path: "/learn/:language/:topic", element: <CourseShell><LearnVocabPage /></CourseShell> },
  { path: "/updates", element: <UpdatesPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <BlogPostPage /> },
  // Public course catalog + syllabus pages. Logged-in users get the app shell,
  // guests get an indexable marketing shell (see CourseShell in guards.jsx).
  { path: "/courses", element: <CourseShell><CoursesPage /></CourseShell> },
  { path: "/course/:slug", element: <CourseShell><CoursePage /></CourseShell> },
  { path: "/deck/:id", element: <CourseShell><DeckPage /></CourseShell> },
  { path: "/marketplace", element: <CourseShell><MarketplacePage /></CourseShell> },
  { path: "/pricing", element: <CourseShell><PricingPage /></CourseShell> },
  { path: "/email-verified", element: <EmailVerifiedPage /> },
  { path: "/auth/callback", element: <AuthCallbackPage /> },
  { path: "/resources", element: <Navigate to="/learn" replace /> },
];

// Public routes but redirected to /home when already authenticated
export const publicOnlyRoutes = [
  { path: "/", element: <RootPage /> },
  { path: "/login", element: <LoginPage /> },
];

// Authenticated routes rendered inside the AppLayout shell
export const appRoutes = [
  { path: "/home", element: <HomePage /> },
  { path: "/explore", element: <ExplorePage /> },
  { path: "/explore/tags/:tag?", element: <ExplorePage /> },
  { path: "/notifications", element: <NotificationPage /> },
  { path: "/profile/:userId", element: <ProfilePage /> },
  { path: "/profile/username/:username", element: <ProfilePage /> },
  { path: "/profile/:userId/settings", element: <ProfilePage /> },
  { path: "/profile/:userId/followers", element: <FollowersPage /> },
  { path: "/profile/:userId/following", element: <FollowingPage /> },
  { path: "/decks", element: <DecksPage /> },
  { path: "/decks/edit/:deckId", element: <EditDeckPage /> },
  { path: "/study/:deckId", element: <StudyPage /> },
  { path: "/stats", element: <StatsPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/kanki-community", element: <SharedConfigsPage /> },
  { path: "/forum", element: <ForumPage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/leaderboards", element: <LeaderboardsPage /> },
  { path: "/post/:postId", element: <PostPage /> },
];
